import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';

interface BaseRemoveColorPanelProps {
  removeColorValue: RGBA;

  onUpdateRemoveColor(removeColorValue: RGBA, undoable?: boolean): void;
}

export function BaseRemoveColorPanel({...props}: BaseRemoveColorPanelProps): ReactElement<any> {
  const updateRemoveColor = (removeColorValue: RGBA, undoable = true): void => {
    props.onUpdateRemoveColor(removeColorValue, undoable);
  };

  const onChangeRemoveColorValue = (updatedColor: ColorStorage[]): void => {
    updateRemoveColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateRemoveColor(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };

  return (
    <PosterEditingBaseColorPanel
      id="custom-shadow-color-panel"
      isGradientEnabled={false}
      color={getColorObjectArrayFromFillColor([props.removeColorValue])}
      onChangeColor={onChangeRemoveColorValue}
      onChangeEnded={onChangeColorEnded}
      isAlphaDisabled
    />
  );
}
